/* eslint-disable camelcase */
/* eslint-disable no-param-reassign */
/* eslint-disable consistent-return */
import Fuse from 'fuse.js';
import { orderBy } from 'lodash';

import { initialState, actionTypes } from './licensesContext';

export const licensesReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_LICENSE_LIST_IS_LOADING:
      state.licenseListIsLoading = action.licenseListIsLoading;

      return state;
    case actionTypes.SET_VIEW_LIST:
      state.viewList = action.viewList;

      return state;
    case actionTypes.UPDATE_VIEW_LIST: {
      const {
        update: { id, assigned, available, authV3Enabled },
      } = action;
      const found = state.viewList.find((license) => license.id === id);

      if (authV3Enabled) {
        found.numberOfLicensesAssigned = assigned;
        found.numberOfLicensesAvailable = available;
      } else {
        found.number_of_licenses_assigned = assigned;
        found.number_of_licenses_available = available;
      }

      return state;
    }
    case actionTypes.SET_LICENSE_LIST:
      state.licenseList = action.licenseList;

      return state;
    case actionTypes.SET_SORT:
      state.sortType = action.sortType;

      if (state.sortField === action.sortField) {
        if (state.sortDirection === 'asc') {
          state.sortDirection = 'desc';
        } else {
          state.sortDirection = 'asc';
        }
      } else {
        state.sortField = action.sortField;
        state.sortDirection = 'asc';
      }

      return state;
    case actionTypes.SET_EDIT_LICENSE_ASSIGNMENT:
      state.editLicenseAssignment = action.license;

      return state;
    case actionTypes.SET_BULK_REQUEST_BODY: {
      // If there is a duplicate entry remove it also works, because you're
      // either adding or removing... there is no way to add or remove a license twice.
      let result = [];
      let found;
      if (action.authV3Enabled) {
        found = state.bulkRequestBody.find((user) => {
          return user.userUuid === action.bulkRequestBody.userUuid;
        });
        if (found) {
          result = state.bulkRequestBody.filter(
            (user) => user.userUuid !== action.bulkRequestBody.userUuid,
          );
          state.bulkRequestBody = result;

          return state;
        }
      } else {
        found = state.bulkRequestBody.find((user) => {
          return user.profile_id === action.bulkRequestBody.profile_id;
        });
        if (found) {
          result = state.bulkRequestBody.filter(
            (user) => user.profile_id !== action.bulkRequestBody.profile_id,
          );
          state.bulkRequestBody = result;

          return state;
        }
      }

      state.bulkRequestBody = [
        ...state.bulkRequestBody,
        action.bulkRequestBody,
      ];

      return state;
    }
    case actionTypes.SET_LICENSES_USER_LIST: {
      const sortedUserList = orderBy(
        action.licensesUserList,
        ['first_name'],
        ['asc'],
      );

      state.licensesUserList = sortedUserList;
      state.filteredUserList = sortedUserList;

      return state;
    }
    case actionTypes.SET_SELECTED_USER_LIST: {
      const { authV3Enabled, profileIds } = action;
      const licensedUsers = [];
      const userList = [...state.licensesUserList];

      profileIds.forEach((id) => {
        const found = userList.find((user) => {
          if (authV3Enabled) {
            return user.nextivaUuid === id;
          }
          return Number(user.profiles[0].id) === Number(id);
        });

        if (found) licensedUsers.push(found);
      });

      state.selectedUserList = [...licensedUsers];
      state.initialSelectedUserList = [...licensedUsers];

      return state;
    }
    case actionTypes.SET_NEWLY_SELECTED_USER_LIST: {
      const found = state.newlySelectedUserList.find(
        (user) => user.email === action.email,
      );

      if (found) {
        state.newlySelectedUserList = state.newlySelectedUserList.filter(
          (user) => user.email !== action.email,
        );

        return state;
      }

      state.newlySelectedUserList = [
        ...state.newlySelectedUserList,
        action.email,
      ];

      return state;
    }
    case actionTypes.SET_USER_CHECKED_STATE: {
      const userIndex = state.selectedUserList.findIndex((u) => {
        return u.email === action.email;
      });

      if (action.authV3Enabled) {
        if (userIndex === -1) {
          const user = state.licensesUserList.find((u) => {
            return u.email === action.email;
          });

          state.selectedUserList = [...state.selectedUserList, user];
          if (
            state.selectedUserList.length <=
            state.editLicenseAssignment.licenseCount
          ) {
            state.editLicenseAssignment.numberOfLicensesAssigned += 1;
            state.editLicenseAssignment.numberOfLicensesAvailable -= 1;
          }
        } else {
          // remove user from list
          state.selectedUserList = state.selectedUserList.filter((u) => {
            return u.email !== action.email;
          });
          if (
            state.selectedUserList.length <=
            state.editLicenseAssignment.licenseCount
          ) {
            if (
              state.selectedUserList.length ===
              state.editLicenseAssignment.licenseCount
            ) {
              state.editLicenseAssignment.numberOfLicensesAssigned =
                state.editLicenseAssignment.licenseCount;
              state.editLicenseAssignment.numberOfLicensesAvailable = 0;
            } else {
              state.editLicenseAssignment.numberOfLicensesAssigned -= 1;
              state.editLicenseAssignment.numberOfLicensesAvailable += 1;
            }
          }
        }

        return state;
      }

      if (userIndex === -1) {
        const user = state.licensesUserList.find((u) => {
          return u.email === action.email;
        });

        state.selectedUserList = [...state.selectedUserList, user];
        if (
          state.selectedUserList.length <=
          state.editLicenseAssignment.license_count
        ) {
          state.editLicenseAssignment.number_of_licenses_assigned += 1;
          state.editLicenseAssignment.number_of_licenses_available -= 1;
        }
      } else {
        // remove user from list
        state.selectedUserList = state.selectedUserList.filter((u) => {
          return u.email !== action.email;
        });
        if (
          state.selectedUserList.length <=
          state.editLicenseAssignment.license_count
        ) {
          if (
            state.selectedUserList.length ===
            state.editLicenseAssignment.license_count
          ) {
            state.editLicenseAssignment.number_of_licenses_assigned =
              state.editLicenseAssignment.license_count;
            state.editLicenseAssignment.number_of_licenses_available = 0;
          } else {
            state.editLicenseAssignment.number_of_licenses_assigned -= 1;
            state.editLicenseAssignment.number_of_licenses_available += 1;
          }
        }
      }

      return state;
    }
    case actionTypes.FILTER_USER_LIST_BY_SEARCH: {
      if (!action.searchString || action.searchString.length === 0) {
        state.filteredUserList = state.licensesUserList;

        return state;
      }

      const fuse = new Fuse(state.licensesUserList, {
        shouldSort: false,
        threshold: 0.25,
        keys: ['first_name', 'last_name', 'email'],
      });

      state.filteredUserList = fuse.search(action.searchString);

      return state;
    }
    case actionTypes.SELECT_ALL_LICENSED_USERS: {
      const updatedBulkRequestBody = [];

      if (action.data.authV3Enabled) {
        if (action.data.checked) {
          state.selectedUserList = [...action.data.userList];

          action.data.userList.forEach((selectedUser) => {
            if (!action.data.initialSelectedUserList.includes(selectedUser)) {
              updatedBulkRequestBody.push({
                userUuid: selectedUser.nextivaUuid,
                action: 'ADD',
              });
            }
          });

          if (
            state.selectedUserList.length <=
            state.editLicenseAssignment.numberOfLicensesAvailable
          ) {
            state.editLicenseAssignment.numberOfLicensesAssigned =
              action.data.userList.length;
            state.editLicenseAssignment.numberOfLicensesAvailable -=
              action.data.userList.length;
          }
        } else if (action.data.license_type === 'BASE') {
          state.selectedUserList = [...action.data.initialSelectedUserList];
          state.editLicenseAssignment.numberOfLicensesAssigned =
            action.data.initialSelectedUserList.length;
          state.editLicenseAssignment.numberOfLicensesAvailable =
            state.editLicenseAssignment.licenseCount -
            action.data.initialSelectedUserList.length;
        } else {
          action.data.initialSelectedUserList.forEach((selectedUser) => {
            updatedBulkRequestBody.push({
              userUuid: selectedUser.nextivaUuid,
              action: 'REMOVE',
            });
          });

          state.selectedUserList = [];
          state.editLicenseAssignment.numberOfLicensesAssigned = 0;
          state.editLicenseAssignment.numberOfLicensesAvailable =
            state.editLicenseAssignment.licenseCount;
        }

        state.bulkRequestBody = updatedBulkRequestBody;
        return state;
      }

      if (action.data.checked) {
        state.selectedUserList = [...action.data.userList];

        action.data.userList.forEach((selectedUser) => {
          if (!action.data.initialSelectedUserList.includes(selectedUser)) {
            updatedBulkRequestBody.push({
              profile_id: `${selectedUser.profiles[0].id}`,
              action: 'ADD',
            });
          }
        });

        if (
          state.selectedUserList.length <=
          state.editLicenseAssignment.number_of_licenses_available
        ) {
          state.editLicenseAssignment.number_of_licenses_assigned =
            action.data.userList.length;
          state.editLicenseAssignment.number_of_licenses_available -=
            action.data.userList.length;
        }
      } else if (action.data.license_type === 'BASE') {
        state.selectedUserList = [...action.data.initialSelectedUserList];
        state.editLicenseAssignment.number_of_licenses_assigned =
          action.data.initialSelectedUserList.length;
        state.editLicenseAssignment.number_of_licenses_available =
          state.editLicenseAssignment.license_count -
          action.data.initialSelectedUserList.length;
      } else {
        action.data.initialSelectedUserList.forEach((selectedUser) => {
          updatedBulkRequestBody.push({
            profile_id: `${selectedUser.profiles[0].id}`,
            action: 'REMOVE',
          });
        });

        state.selectedUserList = [];
        state.editLicenseAssignment.number_of_licenses_assigned = 0;
        state.editLicenseAssignment.number_of_licenses_available =
          state.editLicenseAssignment.license_count;
      }

      state.bulkRequestBody = updatedBulkRequestBody;
      return state;
    }
    case actionTypes.SORT_LICENSES_USER_LIST: {
      const sortedUserList = orderBy(
        [...state.licensesUserList],
        ['first_name'],
        action.ascendingSort ? ['asc'] : ['desc'],
      );

      state.filteredUserList = sortedUserList;
      return state;
    }
    case actionTypes.RESET_EDIT_ASSIGNMENT_DRAWER:
      state.bulkRequestBody = [];
      state.selectedUserList = [];
      state.filteredUserList = state.licensesUserList;
      state.newlySelectedUserList = [];

      return state;
    case actionTypes.TOGGLE_PURCHASE_LICENSE_MODAL:
      state.purchaseLicenseModalOpen = !state.purchaseLicenseModalOpen;
      state.purchaseLicenseAssignment = action.license;
      return state;
    case actionTypes.TOGGLE_SAVE_CHANGES_MODAL:
      state.saveChangesModalOpen = !state.saveChangesModalOpen;
      return state;
    case actionTypes.TOGGLE_TEN_REMOVALS_MODAL:
      state.tenRemovalsModalOpen = !state.tenRemovalsModalOpen;
      return state;
    case actionTypes.TOGGLE_PURCHASE_LICENSE_CONFIRMATION_PAGE:
      state.purchaseLicenseConfirmationPageOpen = !state.purchaseLicenseConfirmationPageOpen;
      return state;
    case actionTypes.SET_PRISTINE:
      state.pristine = action.pristine;
      return state;
    default:
      return state;
  }
};
